module.exports = __webpack_public_path__ + "media/components/images/panels/3-b-a9b71a8a8e055c429e739418a06decb2.jpeg";